export default [
  {
    quote: 'I think you travel to search and you come back home to find yourself there',
    who: 'Chimamanda Ngozi Adichie',
  },
  {
    quote: 'I believe one has to escape oneself to discover oneself',
    who: 'Rabih Alameddine',
  },
  {
    quote: 'If I cease searching, then, woe is me, I am lost. That is how I look at it - keep going, keep going come what may',
    who: 'Vincent van Gogh',
  },
  {
    quote: 'What we find changes who we become',
    who: 'Peter Morville',
  },
  {
    quote: 'The center that I cannot find is known to my unconscious mind',
    who: 'W. H. Auden',
  },
  {
    quote: 'People say that what we\'re seeking is a meaning for life... I think that what we\'re seeking is an experience of being alive, so that we actually feel the rapture of being alive',
    who: 'Joseph Campbell',
  },
  {
    quote: 'And so I search for truth through my art, which is to say, my art is only a vehicle for my freedom',
    who: 'Ian Factor',
  },
  {
    quote: 'Work that is most notable for its newness grows old quickly. We are searching for something timeless rather than timely',
    who: 'Jeffrey Hessing',
  },
  {
    quote: 'Creativity exists more in the searching than in the finding',
    who: 'Stephen Nachmanovitch',
  },
  {
    quote: 'Treasures are hidden away in quiet places. They speak in soft tones and often become silenced as we approach.  They don’t beg to be found, but embrace us if we do happen to find them.  They are the product of completely ordinary circumstances unfolding in wonderfully extraordinary ways.  They are found hidden in the nooks and crannies of our existence; all around us if we quit allowing our attention to be captivated by that which is noisy and listen for that which is quiet and still',
    who: 'Craig D. Lounsbrough',
  },
  {
    quote: 'I was always looking outside myself for strength and confidence but it comes from within. It is there all the time',
    who: 'Anna Freud',
  },
];
